import React from 'react';
import { useFieldAttributes } from '../../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../../sdk/components-wut';
import { DateFieldWUT } from '../../../ui/date-field';
import { getDatePartsErrors } from '../../../ui/date-field/date-field-utils';
export const ContactsBirthdateWUT = (props)=>{
    const { id, description, target, value, error, hasError = false, errorMessage, hideLabel, required, label, requiredIndicatorType, requiredIndicatorPlacement, FieldLayout } = props;
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    // FixMe: Temporary fallback, once we migrate all the forms we can remove both the fallback and the property
    const hidePlaceholder = props.hidePlaceholder ?? props.placeholder === 'none';
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(DateFieldWUT, {
                ...props,
                errors: getDatePartsErrors(hasError, value ?? ''),
                hidePlaceholder: hidePlaceholder,
                inputId: inputId,
                ariaLabelledBy: labelId,
                value: value,
                ariaDescribedBy: ariaDescribedBy
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=contacts-birthdate-wut.js.map